<template>
  <el-drawer
    :append-to-body="true"
    :close-on-click-modal="false"
    :title="$t('orderCenterCont.ViewDetails')"
    :visible="visible"
    custom-class="order-log-drawer"
    direction="ltr"
    size="70%"
    @update:visible="$emit('update:visible', $event)"
  >
    <div class="preStyle">
      <el-form
        ref="updateForm"
        :model="updateForm"
        style="padding: 20px; height: calc(100vh - 68px); overflow-y: auto"
      >
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <!--订单号-->
              <el-form-item
                :label="$t('orderCenterCont.TheOrderNumber') + '：'"
                prop="orderNumber"
              >
                <span>{{ updateForm.orderNumber }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--客户-->
              <el-form-item :label="$t('operationCenter.client') + '：'" prop="customerName">
                <span>{{ updateForm.customerName }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--请求时间-->
              <el-form-item :label="$t('orderCenterCont.RequestTime') + '：'" prop="createTime">
                <span>{{ updateForm.createTime }}</span>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <receive-address-comparison :record="updateForm" />
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--安骏参数-->
              <el-form-item label-width="0">
                <div>
                  {{ $t('orderCenterCont.AnjunParameters') }}
                </div>
                <div class="messageCon">
                  <div
                    v-if="updateForm.dealedRequestParams"
                    style="text-align: right; line-height: 25px; padding: 5px"
                  >
                    <i
                      :title="$t('orderCenterCont.copy')"
                      class="el-icon-copy-document"
                      style="font-size: 20px; cursor: pointer"
                      @click="copy(updateForm.dealedRequestParams)"
                    />
                  </div>
                  <pre>{{ updateForm.dealedRequestParams }}</pre>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--安骏返回参数-->
              <el-form-item label-width="0">
                <div>
                  {{ $t('orderCenterCont.AnjunReturnsParameters') }}
                </div>
                <div class="messageCon">
                  <div
                    v-if="updateForm.dealedResponseParams"
                    style="text-align: right; line-height: 25px; padding: 5px"
                  >
                    <i
                      :title="$t('orderCenterCont.copy')"
                      class="el-icon-copy-document"
                      style="font-size: 20px; cursor: pointer"
                      @click="copy(updateForm.dealedResponseParams)"
                    />
                  </div>
                  <pre>{{ updateForm.dealedResponseParams }}</pre>
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--供应商参数-->
              <el-form-item label-width="0">
                <div>
                  {{ $t('orderCenterCont.SupplierParameters') }}
                </div>
                <div class="messageCon">
                  <div
                    v-if="updateForm.originalRequestParams"
                    style="text-align: right; line-height: 25px; padding: 5px"
                  >
                    <i
                      :title="$t('orderCenterCont.copy')"
                      class="el-icon-copy-document"
                      style="font-size: 20px; cursor: pointer"
                      @click="copy(updateForm.originalRequestParams)"
                    />
                  </div>
                  <pre>{{ updateForm.originalRequestParams }}</pre>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--供应商返回参数-->
              <el-form-item label-width="0">
                <div>
                  {{ $t('orderCenterCont.SupplierReturnsParameters') }}
                </div>
                <div class="messageCon">
                  <div
                    v-if="updateForm.originalResponseParams"
                    style="text-align: right; line-height: 25px; padding: 5px"
                  >
                    <i
                      :title="$t('orderCenterCont.copy')"
                      class="el-icon-copy-document"
                      style="font-size: 20px; cursor: pointer"
                      @click="copy(updateForm.originalResponseParams)"
                    />
                  </div>
                  <pre>{{ updateForm.originalResponseParams }}</pre>
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--客户参数-->
              <el-form-item label-width="0">
                <div>
                  {{ $t('orderCenterCont.CustomerParameters') }}
                </div>
                <div class="messageCon">
                  <div
                    v-if="updateForm.requestParams"
                    style="text-align: right; line-height: 25px; padding: 5px"
                  >
                    <i
                      :title="$t('orderCenterCont.copy')"
                      class="el-icon-copy-document"
                      style="font-size: 20px; cursor: pointer"
                      @click="copy(updateForm.requestParams)"
                    />
                  </div>
                  <pre>{{ updateForm.requestParams }}</pre>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <!--客户返回参数-->
              <el-form-item label-width="0">
                <div>
                  {{ $t('orderCenterCont.CustomerReturnParameters') }}
                </div>
                <div class="messageCon">
                  <div
                    v-if="updateForm.responseParams"
                    style="text-align: right; line-height: 25px; padding: 5px"
                  >
                    <i
                      :title="$t('orderCenterCont.copy')"
                      class="el-icon-copy-document"
                      style="font-size: 20px; cursor: pointer"
                      @click="copy(updateForm.responseParams)"
                    />
                  </div>
                  <pre>{{ updateForm.responseParams }}</pre>
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>
<script>
import { copyData } from '@/utils/copyData';
import ReceiveAddressComparison from './ReceiveAddressComparison.vue';
export default {
  name: 'OrderLogDrawer',
  components: { ReceiveAddressComparison },
  props: {
    visible: { type: Boolean, default: false },
    updateForm: { type: Object, default: () => ({}) }
  },
  methods: { copy: copyData }
};
</script>
<style>
.order-log-drawer .el-drawer__header { border-bottom: 1px solid #e5e6eb; margin-bottom: 0; padding: 20px; }
.order-log-drawer .preStyle { height: calc(100vh - 70px); overflow: hidden; }
.order-log-drawer .messageCon { background: #f7f8fa; }
.order-log-drawer pre { max-height: 500px; overflow: auto; white-space: break-spaces; margin: 0; padding: 0 10px; line-height: 26px; }
</style>
